module.exports = __webpack_public_path__ + "static/media/peeking-peering-over-svgrepo-com.3c64e8ec.svg";